import React from 'react';

/**
 * OscAir logó – logo-warm.png (docs/logo-variations)
 */

const logoWarm = '/logo-warm.png';

export const LogoWhite = ({ className = "" }) => (
  <img
    src={logoWarm}
    alt="OscAir – OscAir.hu"
    className={`logo-img ${className}`.trim()}
    style={{ width: 'auto', objectFit: 'contain', display: 'block', mixBlendMode: 'multiply' }}
  />
);

export const Logo = ({ className = "" }) => (
  <img
    src={logoWarm}
    alt="OscAir – OscAir.hu"
    className={className}
    style={{ height: 48, width: 'auto', objectFit: 'contain', display: 'block' }}
  />
);

export const LogoWarm = Logo;
export const LogoMonoDark = Logo;
export const LogoMonoBlue = Logo;
export const LogoTeal = Logo;
